// SLA helpers for badge displays
import { formatRelative } from "@/lib/utils";

export const slaInfo = (deadlineIso) => {
    if (!deadlineIso) return { label: "—", variant: "neutral", remainingMs: null, pct: 100 };
    const dl = new Date(deadlineIso).getTime();
    const now = Date.now();
    const remaining = dl - now;
    if (remaining <= 0) {
        return { label: "Vencido", variant: "error", remainingMs: remaining, pct: 0 };
    }
    const totalHours = remaining / 3600000;
    if (totalHours < 2) {
        return {
            label: `${Math.round(totalHours * 60)} min`,
            variant: "error",
            remainingMs: remaining,
            pct: 15,
        };
    }
    if (totalHours < 12) {
        return {
            label: `${totalHours.toFixed(1)} h`,
            variant: "warning",
            remainingMs: remaining,
            pct: 50,
        };
    }
    const days = totalHours / 24;
    if (days < 1) {
        return { label: `${totalHours.toFixed(0)} h`, variant: "info", remainingMs: remaining, pct: 75 };
    }
    return { label: `${days.toFixed(1)} d`, variant: "success", remainingMs: remaining, pct: 100 };
};

export const formatAOAFull = (v) => {
    if (v == null) return "—";
    return new Intl.NumberFormat("pt-PT", { maximumFractionDigits: 0 }).format(v);
};

export const formatRel = formatRelative;
